import React from 'react'
import { Link } from 'react-router-dom'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import ButtonBase from '@material-ui/core/ButtonBase'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardHeader from '@material-ui/core/CardHeader'
import TextField from '@material-ui/core/TextField'
import CardActions from '@material-ui/core/CardActions'
import Chip from '@material-ui/core/Chip'
import IconButton from '@material-ui/core/IconButton'
import CircularProgress from '@material-ui/core/CircularProgress'

import CommentIcon from '@material-ui/icons/Comment'
import SearchIcon from '@material-ui/icons/Search'
import ThumbUpIcon from '@material-ui/icons/ThumbUp'
import ThumbDownIcon from '@material-ui/icons/ThumbDown'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'

import withStyles from '@material-ui/core/styles/withStyles'

import { getLevelIcon, makePath } from '../../../lib'
import TimeAgo from 'react-timeago'
import jaStrings from 'react-timeago/lib/language-strings/ja'
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter'
import dateformat from 'dateformat'
import { Word } from '../../../containers';
import { WID, getWord } from '../../../constants/Language';
import { useEffect } from 'react'
import { useContext } from 'react'
import { SettingsContext } from '../../../Parts/Settings'
import CustomAvatar from '../../../Parts/CustomAvatar/CustomAvatar'
import { Auth0Context } from '../../../Parts/Auth0'
import { useState } from 'react'
const formatter = buildFormatter(jaStrings)

const stylesSearchCardHeader = theme => ({
  cardHeaderAction: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    margin: theme.spacing.unit * 2,
  },
  icon: {
    margin: theme.spacing.unit,
    color: theme.palette.grey['500']
  },
  textField: {

  }
})

class SearchCardHeader extends React.Component {
  render() {
    const { classes, onKeyDown, disabled, language } = this.props
    return (
      <CardHeader
        action={
          <div className={classes.cardHeaderAction}>
            <SearchIcon className={classes.icon}/>
            <TextField
              disabled={disabled}
              className={classes.textField}
              placeholder={getWord(WID.PUZZLE_LIST_CARD.SEARCH_PLACE_HOLDER, language)}
              onKeyDown={onKeyDown}
            />
          </div>
        }
      />
    )
  }
}

SearchCardHeader = withStyles(stylesSearchCardHeader)(SearchCardHeader)

const stylesSearchResultCardContent = theme => ({
  cardContent: {
    display: 'flex',
    alignItems: 'center',
  },
  searchTagChip: {
    marginRight: theme.spacing.unit,
    zIndex: 100,
  },
  searchResult: {
    marginLeft: theme.spacing.unit,
  },
})

class SearchResultCardContent extends React.Component {
  render() {
    const { classes, search, totalRows } = this.props
    if (search && search.tag) {
      return (
        <CardContent className={classes.cardContent}>
          <Chip label={search.tag} className={classes.searchTagChip}></Chip>
          <Typography variant='body2'>
            <Word wid={WID.PUZZLE_LIST_CARD.MESSAGE_FIND_TAG} insert={{ totalRows }}/>
          </Typography>
        </CardContent>
      )
    }
    else if (search && search.word) {
      return (
        <CardContent>
          {totalRows > 0 ? (
            <Typography className={classes.searchResult}>
              <Word wid={WID.PUZZLE_LIST_CARD.MESSAGE_FIND_WORD} insert={{ word: search.word, totalRows }}/>
            </Typography>
          ) : (
            <Typography className={classes.searchResult}>
              <Word wid={WID.PUZZLE_LIST_CARD.MESSAGE_DONT_FIND_WORD} insert={{ word: search.word }}/>
            </Typography>
          )}
        </CardContent>
      )
    }
    else {
      return (<div></div>)
    }
  }
}

SearchResultCardContent = withStyles(stylesSearchResultCardContent)(SearchResultCardContent)

const stylesRecordsCardContent = theme => ({
  cardContent: {
    padding: 0,
  },
  gridRecord: {
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    margin: 0,
    padding: theme.spacing.unit * 1.5,
    textAlign: 'left',
  },
  gridRecordHeader: {
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    margin: 0,
    padding: theme.spacing.unit * 1.5,
    textAlign: 'left',
    backgroundColor: theme.palette.grey[100],
  },
  gridTag: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  chip: {
    margin: theme.spacing.unit / 2,
  },
  buttonBase: {
    width: '100%'
  },
  titleAndAuthorBox: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing.unit * 1,
    width: 40,
    height: 40,
  },
  title: {
    fontWeight: 'bold',
  },
  displayNameAndTimeAgoBox: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.grey[700],
  },
  displayName: {
    fontSize: '0.75rem',
  },
  datetime: {
    fontSize: '0.75rem',
    color: theme.palette.grey[700],
  },
  thumbIcon: {
    color: theme.palette.grey[500],
    margin: theme.spacing.unit,
  },
  goodNumber: {
    color: theme.palette.grey[500],
    margin: theme.spacing.unit,
  },
  badNumber: {
    color: theme.palette.grey[500],
    margin: theme.spacing.unit,
  },
  commentsIcon: {
    color: theme.palette.grey[500],
    margin: theme.spacing.unit,
  },
  commentsLength: {
    color: theme.palette.grey[500],
    margin: theme.spacing.unit,
  },
  flexBox: {
    display: 'flex',
  }
})

const RecordsCardContent = withStyles(stylesRecordsCardContent, { withTheme: true })((props) => {
  const { classes, theme, records, disabled } = props
  const settingsContext = useContext(SettingsContext)
  const { language } = settingsContext

  var title, turnItem, typeItem, commentsLength, thumbUpButtonProp, thumbDownButtonProp
  if (records && records.length > 0) {
    return (
      <CardContent className={classes.cardContent}>
        <Grid container spacing={8} alignItems='center' className={classes.gridRecordHeader}>
          <Grid item sm={5} xs={12}><Typography><Word wid={WID.PUZZLE_LIST_CARD.TITLE_LABEL}/></Typography></Grid>
          <Grid item sm={2} xs={4}><Typography><Word wid={WID.PUZZLE_LIST_CARD.TURN_LABEL}/></Typography></Grid>
          <Grid item sm={2} xs={4}><Typography><Word wid={WID.PUZZLE_LIST_CARD.PUZZLE_TYPE_LABEL}/></Typography></Grid>
          <Grid item sm={3} xs={4}><Typography><Word wid={WID.PUZZLE_LIST_CARD.LEVEL_LABEL}/></Typography></Grid>
        </Grid>
        {records.map((record, index) => {
          title = record.title ? record.title : 'untitled'
          turnItem = turnItems.find((item) => item.value === record.tr)
          typeItem = typeItems.find((item) => item.value === record.pt)
          commentsLength = record.comments.length > 0 ? 
            (record.comments[0].comment ? record.comments.length : record.comments.length - 1) : 0
          thumbUpButtonProp = record.isSelectedGood === true ?
            { style: { color: theme.palette.primary.main } } : { style: { color: theme.palette.grey[500] } }
          thumbDownButtonProp = record.isSelectedBad === true ?
            { style: { color: theme.palette.primary.main } } : { style: { color: theme.palette.grey[500] } }

          return (
            <ButtonBase disabled={disabled} key={index} className={classes.buttonBase} component={Link} to={makePath(`/puzzle/${record.id}`, language)}>
              <Grid container spacing={8} key={index} alignItems='center' className={classes.gridRecord}>
                <Grid item sm={5} xs={12}>
                  <div className={classes.titleAndAuthorBox}>
                    <CustomAvatar
                      alt={record.author.displayName}
                      name={record.author.displayName}
                      src={record.author.photoURL}
                      className={classes.avatar}
                      key={record.id}
                    />
                    <div>
                      <Typography className={classes.title} noWrap>{title}</Typography>
                      <div className={classes.displayNameAndTimeAgoBox}>
                        <Typography noWrap color='inherit' className={classes.displayName}>{record.author.displayName}</Typography>
                        {record.datetime < Date.now() && (
                          <Typography color='inherit' className={classes.datetime}>・<TimeAgo date={record.datetime} formatter={formatter}/></Typography>
                        )}
                      </div>
                      {record.datetime >= Date.now() && (
                        <Typography color='inherit' className={classes.datetime}>
                          <Word wid={WID.PUZZLE_LIST_CARD.RELEASE_DATE_LABEL}/>: {dateformat(record.datetime, 'yyyy/m/d HH:MM')}
                        </Typography>
                      )}
                    </div>
                  </div>
                </Grid>
                <Grid item sm={2} xs={4}>
                  {turnItem && (
                    <Typography><Word wid={turnItem.wid}/></Typography>
                  )}
                </Grid>
                <Grid item sm={2} xs={4}>
                  {typeItem && (
                    <Typography><Word wid={typeItem.wid}/></Typography>
                  )}
                </Grid>
                <Grid item sm={3} xs={4}>
                  {getLevelIcon(record.lv, 16)}
                </Grid>
                <Grid item xs={12} className={classes.gridTag}>
                  {record.tags && record.tags.length > 0 && record.tags.map((tag, index) => 
                    <Chip
                      key={index}
                      label={tag}
                      className={classes.chip}
                    />
                  )}
                  <div className={classes.flexBox}>
                    <ThumbUpIcon className={classes.thumbIcon} {...thumbUpButtonProp}/>
                    <Typography className={classes.goodNumber} variant='body2' {...thumbUpButtonProp}>{record.goodNumber}</Typography>
                    <ThumbDownIcon className={classes.thumbIcon} {...thumbDownButtonProp}/>
                    <Typography className={classes.badNumber} variant='body2' {...thumbDownButtonProp}>{record.badNumber}</Typography>
                    <CommentIcon className={classes.commentsIcon}/>
                    <Typography className={classes.commentsLength} variant='body2'>{commentsLength}</Typography>
                  </div>
                </Grid>
              </Grid>
            </ButtonBase>
          )
        })}
      </CardContent>
    )
  }
  else {
    return (<div></div>)
  }
})

const stylesPageNavigationCardActions = theme => ({
  cardActions: {
    justifyContent: 'flex-end',
  }
})

class PageNavigationCardActions extends React.Component {
  render() {
    const { classes, pageNaviText, enableBackPage, enableNextPage, onClickLeft, onClickRight, disabled } = this.props
    return (
      <CardActions className={classes.cardActions}>
        <Typography className={classes.pageNaviText}>{pageNaviText}</Typography>
        <IconButton onClick={onClickLeft} disabled={!enableBackPage || disabled}>
          <ChevronLeftIcon/>
        </IconButton>
        <IconButton onClick={onClickRight} disabled={!enableNextPage || disabled}>
          <ChevronRightIcon/>
        </IconButton>
      </CardActions>
    )
  }
}

PageNavigationCardActions = withStyles(stylesPageNavigationCardActions)(PageNavigationCardActions)

const styles = theme => ({
  cardContent: {
    display: 'flex',
    justifyContent: 'center'
  }
})

const typeItems = [
  { value: 'VCT', wid: WID.PUZZLE_LIST_CARD.PUZZLE_TYPE_ITEMS.VCT },
  { value: 'VCF', wid: WID.PUZZLE_LIST_CARD.PUZZLE_TYPE_ITEMS.VCF },
]

const turnItems = [
  { value: 'b', wid: WID.PUZZLE_LIST_CARD.TURN_ITEMS.BLACK_FIRST },
  { value: 'w', wid: WID.PUZZLE_LIST_CARD.TURN_ITEMS.WHITE_FIRST },
]

function PuzzleListCard(props) {
  const { classes, records, totalRows, totalPage, search, urlParams, disabledBoxShadow, pageNavigation, searchProp, isFetching, ready } = props
  
  const auth0Context = useContext(Auth0Context)
  const [isInitialized, setIsInitialized] = useState(false)

  const settingsContext = useContext(SettingsContext)
  const { language } = settingsContext

  useEffect(() => {
    if (!isInitialized && auth0Context.isInitialized) {
      props.init(props.author)
      setIsInitialized(true)
    }
    return () => {
      props.unmount()
    }
  }, [auth0Context.isInitialized])

  var endRow, startRow, pageNaviText, enableNextPage, enableBackPage
  var page = urlParams.page ? urlParams.page : 1
  var rowsPerPage = urlParams.rowsPerPage
  var styles = {
    card: {
      boxShadow: disabledBoxShadow ? 'none' : undefined
    }
  }
  startRow = (page - 1) * rowsPerPage + 1
  endRow = page * rowsPerPage < totalRows ? page * rowsPerPage : totalRows
  pageNaviText = totalRows !== 0 ? startRow + '-' + endRow + ' of ' + totalRows : ''
  enableNextPage = Boolean(page < totalPage)
  enableBackPage = Boolean(page > 1)
  return (
    <Card style={styles.card}>
      <SearchCardHeader disabled={isFetching} onKeyDown={searchProp.handleKeyDown(urlParams)} language={language}/>
      <SearchResultCardContent {...{search, totalRows}}/>
      {ready ? (
        <RecordsCardContent {...{records, disabled: isFetching, language}}/>
      ) : (
        <CardContent className={classes.cardContent}>
          <CircularProgress/>
        </CardContent>
      )}
      <PageNavigationCardActions
        onClickLeft={pageNavigation.handleClick('Back', urlParams)}
        onClickRight={pageNavigation.handleClick('Next', urlParams)}
        {...{pageNaviText, enableBackPage, enableNextPage}}
        disabled={isFetching}
      />
    </Card>
  )
}

export default withStyles(styles, { withTheme: true })(PuzzleListCard)



// WEBPACK FOOTER //
// ./src/components/Common/Puzzle/PuzzleListCard.js